import { SBBox, SBIcon, SBTypography } from "modules/Commons";
import { useStyles } from "./style";
import SBForecastEvaluationSectionItem from "../SBForecastEvaluationSectionItem";
import { Trans } from "react-i18next";
import { ReportContent } from "modules/Purchases/components/SBPurchaseReport/style";
import { useSystemLanguage } from "hooks/useSystemLanguage";
import { percentageFormatter } from "utils/formatters";
import { useMemo } from "react";
import clsx from "clsx";
import { SBTranslate } from "i18n";

export default (props: SBForecastEvaluationSectionInfoProps) => {
	const { stats, performance, isOnModal } = props;
	const classes = useStyles();
	const { getLanguage } = useSystemLanguage();

	const config = useMemo(() => ({
		performance: percentageFormatter(Math.abs(performance)),
	} as any), [performance, getLanguage()])

	return (
		<SBBox className={clsx(classes.sectionInfo, isOnModal && "sectionInfoModal")}>
			<SBBox className={clsx(classes.demandCovInfo, isOnModal && "demandCovInfoModal")}>
				{stats?.map((stat) => {
					return (
						<SBBox key={stat.label} display="flex" justifyContent="center" width={1}>
							<SBForecastEvaluationSectionItem
								stat={stat}
								isOnModal={isOnModal}
								isAverage={stat.label === `${SBTranslate("average")}`}
							/>
						</SBBox>
					);
				})}
			</SBBox>
			<SBBox className={clsx(classes.superiorityFactorInfo, isOnModal && "superiorityFactorInfoModal")}>
				<SBIcon icon="sbrain" size={50} className={classes.sbIcon} />
				<SBBox className={clsx(classes.superiorityFactorTextContainer, isOnModal && "superiorityFactorTextContainerModal")}>
					<SBTypography>
						<Trans i18nKey={performance >= 0 ? "views.home.modelPerformanceHigher" : "views.home.modelPerformanceLower"} lang={getLanguage()}>
							<ReportContent>
								{config}
							</ReportContent>
						</Trans>
					</SBTypography>
				</SBBox>
			</SBBox>
		</SBBox>
	);
};

interface SBForecastEvaluationSectionInfoProps {
	stats: {
		tooltip: string;
		label: string;
		formatter: (v?: number | undefined) => string;
		model: {
			forecast: {
				value: any;
				range: string;
			},
			forecastBenchmark?: {
				value: any;
				range: string;
			}
		},
		toCompare: boolean;
	}[],
	performance: number,
	isOnModal: boolean;
}
